import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import { FetchEarnings, listing, FetchArchivedReports } from "./PaymentSlice";
import { GetTeacher } from "../teacher/TeacherSlice";
import { getTeacherId } from "../../app/globalStore";
import { saveFinanceReportToArchive } from "../../api/payment";


function TeacherEarning() {
  const dispatch = useDispatch();
  const teacher_id = getTeacherId();
  const list = useSelector((state) => state?.payment?.list);
  const archivedReports = useSelector((state) => state?.payment?.archivedReports);
  const company_id = useSelector((state) => state.auth?.company_id);
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [loading, setLoading] = useState(false);
  const [teacherId, setTeacherId] = useState("");
  const [view_type, setView_type] = useState("");
  const [output , setOutput] = useState(false);
  const [archiveLoading, setArchiveLoading] = useState(false);
  const [showArchivedReports, setShowArchivedReports] = useState(false);
  const [archivedReportsLoading, setArchivedReportsLoading] = useState(false);


  const handleApplyFilter = () => {
    setOutput(false);
    if (!start_date) {
      toast.error("Please select a start date", { autoClose: false, closeButton: true });
      return;
    }
    if (!end_date) {
      toast.error("Please select an end date", { autoClose: false, closeButton: true });
      return;
    }
    // if (!view_type) {
    //   toast.error("Please select a view type");
    //   return;
    // }
  
    setLoading(true);
    dispatch(
      FetchEarnings({
        view_type: "teacher_wise",
        teacher_id:teacher_id,
        ...(start_date && { start_date: moment(start_date).format("YYYY-MM-DD") }),
        ...(end_date && { end_date: moment(end_date).format("YYYY-MM-DD") })
      })
    ).then(() => {
      setLoading(false);
      setOutput(true);
    });
  };
  
  useEffect(() => {
    if (company_id && teacher_id) {
      setArchivedReportsLoading(true);
      dispatch(FetchArchivedReports(company_id)).finally(() => {
        setArchivedReportsLoading(false);
      });
    }
  }, [dispatch, company_id, teacher_id]);

  useEffect(() => {
    return () => {
      dispatch(listing([]));
    };
  }, [dispatch]);

  const handleSaveToArchives = async () => {
    if (!list || list.length === 0) {
      toast.error("No data to archive", { autoClose: false, closeButton: true });
      return;
    }

    setArchiveLoading(true);
    
    try {
      const payload = {
        company_id: company_id,
        start_date: start_date ? moment(start_date).format('YYYY-MM-DD') : '',
        end_date: end_date ? moment(end_date).format('YYYY-MM-DD') : '',
        teacher_id: teacher_id,
        view_type: "teacher_wise",
        summary_data: JSON.stringify(list)
      };

      const response = await saveFinanceReportToArchive(payload);
      
      if (response?.code === 1) {
        toast.success(response?.message || "Report saved to archives successfully", { autoClose: false, closeButton: true });
        dispatch(FetchArchivedReports(company_id));
      } else {
        toast.error(response?.message || "Failed to save report to archives", { autoClose: false, closeButton: true });
      }
    } catch (error) {
      console.error('Error saving to archives:', error);
      toast.error("An error occurred while saving to archives", { autoClose: false, closeButton: true });
    } finally {
      setArchiveLoading(false);
    }
  };

  return (
    <article className="col-lg-9">
      <div className="article-body store-bd-gy">
        <div className="row">
          <div className="col-md-12">
            <h4>Teacher Earnings</h4>
          </div>
        </div>

        {/* Archived Reports Section */}
        {company_id && teacher_id && (
          <div className="card mt-3" style={{ border: '1px solid #dee2e6', borderRadius: '8px' }}>
            <div 
              className="card-header" 
              style={{ 
                backgroundColor: '#f8f9fa', 
                cursor: 'pointer',
                padding: '15px 20px',
                borderBottom: showArchivedReports ? '1px solid #dee2e6' : 'none'
              }}
              onClick={() => setShowArchivedReports(!showArchivedReports)}
            >
              <div className="d-flex justify-content-between align-items-center">
                <h6 className="mb-0" style={{ fontWeight: '600', color: '#2c3e50' }}>
                  📁 Archived Reports
                  {archivedReports && archivedReports.filter(report => report.teacher_id && report.teacher_id.toString() === teacher_id.toString()).length > 0 && (
                    <span className="badge bg-primary ms-2">{archivedReports.filter(report => report.teacher_id && report.teacher_id.toString() === teacher_id.toString()).length}</span>
                  )}
                </h6>
                <span style={{ fontSize: '14px' }}>{showArchivedReports ? '▲' : '▼'}</span>
              </div>
            </div>
            
            {showArchivedReports && (
              <div className="card-body" style={{ padding: '20px' }}>
                {archivedReports && archivedReports.filter(report => report.teacher_id && report.teacher_id.toString() === teacher_id.toString()).length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr style={{ backgroundColor: '#f8f9fa' }}>
                          <th style={{ padding: '12px 15px', fontWeight: '600', color: '#2c3e50' }}>File Name</th>
                          <th style={{ padding: '12px 15px', fontWeight: '600', color: '#2c3e50' }}>Created Date</th>
                          <th style={{ padding: '12px 15px', fontWeight: '600', color: '#2c3e50', textAlign: 'center' }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {archivedReports.filter(report => report.teacher_id && report.teacher_id.toString() === teacher_id.toString()).map((report, index) => (
                          <tr key={report.id || index}>
                            <td style={{ padding: '12px 15px', verticalAlign: 'middle' }}>
                              <span style={{ color: '#dc3545', marginRight: '8px', fontSize: '16px' }}>📄</span>
                              {report.file_name}
                            </td>
                            <td style={{ padding: '12px 15px', verticalAlign: 'middle' }}>
                              {moment(report.createdAt).format('MMM D, YYYY h:mm A')}
                            </td>
                            <td style={{ padding: '12px 15px', textAlign: 'center', verticalAlign: 'middle' }}>
                              <button
                                className="btn btn-sm btn-outline-primary me-2"
                                onClick={() => {
                                  window.open(`https://api.bookinclass.co.uk/uploads/reports/${report.file_name}`, '_blank');
                                }}
                                title="Download"
                              >
                               Download
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center py-4" style={{ color: '#6c757d' }}>
                    <div style={{ fontSize: '48px', opacity: 0.3, marginBottom: '15px' }}>📂</div>
                    <p className="mb-0">No archived reports found for this teacher.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        <div className="row align-items-end g-2 mt-3">
          <div className="col-md-2">
            <DatePicker
              value={start_date}
              onChange={(val) => {
                setStart_date(val.toDate());
              }}
              containerStyle={{width: '100%'}}
              style={{borderRadius: '10px', border: '1px solid #ced4da', padding: '0.5rem 0.75rem', fontSize: '0.95rem', outline: 'none', boxShadow: 'none', backgroundColor: '#fff', height: '50px', width: '100%'}}
              placeholder="Start Date"
              className="custom-datepicker"
            />
          </div>
          <div className="col-md-2">
            <DatePicker
              value={end_date}
              onChange={(val) => {
                setEnd_date(val.toDate());
              }}
              containerStyle={{width: '100%'}}
              style={{borderRadius: '10px', border: '1px solid #ced4da', padding: '0.5rem 0.75rem', fontSize: '0.95rem', outline: 'none', boxShadow: 'none', backgroundColor: '#fff', height: '50px', width: '100%'}}
              placeholder="End Date"
              minDate={start_date || new Date()}
              className="custom-datepicker"
            />
          </div>
          <div className="col-md-2 d-none">
            <select
              className="form-control form-select"
              value={view_type}
              onChange={(e) => {
                setView_type(e.target.value);
              }}
            >
              <option value="">Select View Type</option>
              <option value="total_income" selected>Total Income</option>
              <option value="total_expense">Total Expense</option>
              <option value="total_money_outstanding">Total Money Outstanding</option>
              <option value="net_pay">Net Pay</option>
            </select>
          </div>
          <div className="col-md-2">
            <button 
              type="button" 
              className="btn btn-save p-2 fs-6 w-100"
              style={{ padding: '1rem', height: '50px', borderRadius: '8px'  }} // increase height
              onClick={handleApplyFilter}
            >
              Apply Filter
            </button>
          </div>
        </div>
        {/* Summary Output Section */}
        {output && (
        <div className="row mt-4">
          <div className="col-sm-12 ">
            <h4 style={{ 
              color: '#2c3e50', 
              fontWeight: '600', 
              marginBottom: '20px',
              fontSize: '24px'
            }}>
              Summary Output
            </h4>
            
            <div style={{ 
              backgroundColor: '#fff', 
              borderRadius: '8px', 
              overflow: 'hidden',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <table className="table mb-0" style={{ marginBottom: 0 }}>
                <thead>
                  <tr style={{ backgroundColor: '#f8f9fa' }}>
                    <th style={{ 
                      padding: '15px 20px', 
                      fontWeight: '600',
                      color: '#2c3e50',
                      borderBottom: '2px solid #dee2e6',
                      fontSize: '14px'
                    }}>
                      Description
                    </th>
                    <th style={{ 
                      padding: '15px 20px', 
                      fontWeight: '600',
                      color: '#2c3e50',
                      borderBottom: '2px solid #dee2e6',
                      textAlign: 'center',
                      fontSize: '14px'
                    }}>
                      Count
                    </th>
                    <th style={{ 
                      padding: '15px 20px', 
                      fontWeight: '600',
                      color: '#2c3e50',
                      borderBottom: '2px solid #dee2e6',
                      textAlign: 'right',
                      fontSize: '14px'
                    }}>
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                {list?.map((item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          padding: "15px 20px",
                          color: item.is_net_total ? "#2c3e50" : "#495057",
                          fontWeight: item.is_net_total ? "600" : "400",
                          borderBottom: item.is_net_total ? "none" : "1px solid #dee2e6",
                        }}
                      >
                        <div style={{ lineHeight: '1.2' }}>
                            <div>{item.desc}</div>
                            {item.note && <div style={{ fontSize: '12px', color: '#6c757d' }}>{item.note}</div>}
                        </div>
                      </td>
                       <td
                        style={{
                          padding: "15px 20px",
                          textAlign: "center",
                          color: item.is_net_total ? "#2c3e50" : "#495057",
                          fontWeight: item.is_net_total ? "600" : "500",
                          fontSize: item.is_net_total ? "16px" : "14px",
                          borderBottom: item.is_net_total ? "none" : "1px solid #dee2e6",
                        }}
                      >
                        {item.total_number}
                      </td>
                      <td
                        style={{
                          padding: "15px 20px",
                          textAlign: "right",
                          color: item.is_net_total ? "#2c3e50" : "#495057",
                          fontWeight: item.is_net_total ? "600" : "500",
                          fontSize: item.is_net_total ? "16px" : "14px",
                          borderBottom: item.is_net_total ? "none" : "1px solid #dee2e6",
                        }}
                      >
                        {item.amount && `£${item.amount}`}
                      </td>
                    </tr>
                  ))}

                </tbody>
              </table>
            </div>

            <div className="mt-3">
              <button 
                type="button" 
                className="btn"
                onClick={handleSaveToArchives}
                disabled={archiveLoading}
                style={{
                  backgroundColor: '#ffc107',
                  color: '#000',
                  padding: '10px 24px',
                  borderRadius: '6px',
                  fontWeight: '500',
                  border: 'none',
                  fontSize: '14px',
                  opacity: archiveLoading ? 0.6 : 1,
                  cursor: archiveLoading ? 'not-allowed' : 'pointer'
                }}
              >
                {archiveLoading ? 'Saving...' : 'Save to Archives'}
              </button>
            </div>
          </div>
        </div>
        )}

        {loading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
              <div className="spinner"></div>
              <p style={{ fontSize: "14px", color: "#555", margin: 0 }}>
                Please wait...Your earning report is being generated.
              </p>
            </div>
          </div>
        ) : (
          <></>
        )}

      </div>
    </article>
  );
}

export default TeacherEarning;
